import React from "react";
import { Navigate, RouterProvider, createBrowserRouter } from "react-router-dom";
import App from "../../App";
import Login from "../Login/Login";
import Survey from "../Survey/Survey";
import Graph from "../Graph/Graph";
import ContactData from "../ContactData/ContactData";
import HistoricalData from "../HistorialData/HistoricalData";
import Questions from "../Questions/Questions";
import RouterErrorComponent from "./RouterErrorComponent";

const Router = () => {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <App />,
            errorElement: <RouterErrorComponent />,
            children: [
                {
                    path: '',
                    element: <Navigate to={'encuesta'} replace />
                },
                {
                    path: "encuesta",
                    element: <Survey />,
                },
                {
                    path: "login",
                    element: <Login />,
                },
                {
                    path: "resultado-diagnostico",
                    element: <Graph />,

                },
                {
                    path: "datos-contacto",
                    element: <ContactData />,

                },
                {
                    path: "historial-encuestas",
                    element: <HistoricalData />,

                },
                // Comentar en producción
                {
                    path: "listado-preguntas",
                    element: <Questions />,

                },
            ],
        },
    ], {});

    return <RouterProvider router={router} />
}

export default Router;